var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 2.79163C5.743 2.79163 2.29199 6.24264 2.29199 10.5C2.29199 14.7573 5.743 18.2083 10.0003 18.2083C13.8639 18.2083 17.0643 15.365 17.6223 11.657C17.6737 11.3156 17.992 11.0806 18.3333 11.1319C18.6747 11.1833 18.9097 11.5016 18.8584 11.843C18.2097 16.1533 14.4918 19.4583 10.0003 19.4583C5.05265 19.4583 1.04199 15.4476 1.04199 10.5C1.04199 5.55228 5.05265 1.54163 10.0003 1.54163C13.2801 1.54163 16.148 3.30447 17.7087 5.93295V2.99996C17.7087 2.65478 17.9885 2.37496 18.3337 2.37496C18.6788 2.37496 18.9587 2.65478 18.9587 2.99996V6.66663C18.9587 6.81435 18.9296 6.96065 18.873 7.09715C18.8165 7.23364 18.7336 7.35766 18.6292 7.46212C18.5247 7.56659 18.4007 7.64945 18.2642 7.70599C18.1277 7.76253 17.9814 7.79163 17.8337 7.79163H17.6547C17.6453 7.79184 17.636 7.79184 17.6266 7.79163H14.167C13.8218 7.79163 13.542 7.5118 13.542 7.16663C13.542 6.82145 13.8218 6.54163 14.167 6.54163H16.6163C15.2688 4.2943 12.8091 2.79163 10.0003 2.79163Z",
    fill: "#004BEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.66e1e311ef7b8bb4fff7e62106ace59b.svg";
export { ForwardRef as ReactComponent };